// @helpers
const {
    APIGet,
    downloadAsFile,
    base64ToBlob,
    APIPost,
} = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { getPublicSiteUrl } = require('core/apiURLBuilder');
const mifidErrorHelper = require('mifid/utilities/mifidErrorHelper');
const errorActions = require('actions/brokerError');
const get = require('lodash/object/get');

// @constants
const actionTypes = require('../constants/actionTypes');
const {
    BROKER_FUND_LEGAL_DOCUMENT_MORNING_STAREXT_SECURTY_DETAILS,
    CONTENT_TYPE_PDF,
    BROKER_DOCUMENT_TYPE,
    BROKER_ORDER_TYPE_BUY,
} = require('constants/index');

const fetchMorningStarExtRequest = isin => ({
    type: actionTypes.CM_LEGAL_DOCUMENT_MORNING_STAR_EXT_FETCH_REQUEST,
    payload: {
        isin,
    },
});

const fetchMorningStarExtSuccess = (response, isin) => ({
    type: actionTypes.CM_LEGAL_DOCUMENT_MORNING_STAR_EXT_FETCH_SUCCESS,
    payload: {
        response,
        isin,
    },
});

const fetchMorningStarExtFailure = (error, isin) => ({
    type: actionTypes.CM_LEGAL_DOCUMENT_MORNING_STAR_EXT_FETCH_FAILURE,
    payload: {
        error,
        isin,
    },
});

const fetchMarketingReportSuccess = (url, isin) => ({
    type: actionTypes.CM_LEGAL_DOCUMENT_MARKETING_REPORTS_FETCH_SUCCESS,
    payload: {
        url,
        isin,
    },
});

const fetchUnifiedDocumentSuccess = (url, isin) => ({
    type: actionTypes.CM_LEGAL_UNIFIED_DOCUMENT_FETCH_SUCCESS,
    payload: {
        url,
        isin,
    },
});

const fetchMorningStarExt = isin => dispatch => {
    const url = apiURLBuilder.getURL('morningstarextSecurityDetailsIsin', {
        morningstarextSecurityDetails: BROKER_FUND_LEGAL_DOCUMENT_MORNING_STAREXT_SECURTY_DETAILS,
        isin,
    });

    dispatch(fetchMorningStarExtRequest(isin));
    APIGet(dispatch, url, {}).then(
        response => dispatch(fetchMorningStarExtSuccess(response, isin)),
        error => dispatch(fetchMorningStarExtFailure(error)),
    );
};

const fetchMarketingReports = isin => dispatch => {
    const publicSiteUrl = getPublicSiteUrl();
    const url = `${publicSiteUrl}/assets/static/pdf/fondos/memorias/${isin}.pdf`;

    dispatch(fetchMarketingReportSuccess(url, isin));
};

const fetchUnifiedDocument = isin => dispatch => {
    const url = apiURLBuilder.getURL('getUnifiedDocument', {
        isin,
        isPrivate: true,
    });

    dispatch(fetchUnifiedDocumentSuccess(url, isin));
};

const fetchFundTransactionCostSuccess = response => ({
    type: actionTypes.CM_LEGAL_DOCUMENT_COST_FETCH_SUCCESS,
    payload: { response },
});

const fetchFundTransactionCostError = error => ({
    type: actionTypes.CM_LEGAL_DOCUMENT_COST_FETCH_ERROR,
    payload: { error },
});

const fetchFundTransactionCostRequest = () => ({
    type: actionTypes.CM_LEGAL_DOCUMENT_COST_FETCH,
    payload: {},
});

const getFundsTransactionDocumentContent = (
    objectID,
    mifidErrorDatePassed,
    immCmLegalDocuments,
    fundIsin,
    history
) => dispatch => {
    const data = {
        query: {
            objectId: objectID,
        },
    };
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('getDocumentContent'),
        data,
    ).then(
        response => {
            if (response && response.content) {
                const result = {
                    objectId: objectID,
                    content: response.content,
                    isin: fundIsin,
                };
                const base64String = `data:${CONTENT_TYPE_PDF};base64,${response.content}`;
                downloadAsFile(
                    base64ToBlob(base64String),
                    CONTENT_TYPE_PDF,
                    objectID,
                );
                dispatch(fetchFundTransactionCostSuccess(result));
            } else {
                if (mifidErrorDatePassed) {
                    dispatch(
                        errorActions.show(
                            'brokerAPIErrors-errorPrimaryMessage',
                            true,
                            history
                        ),
                    );
                }
            }
        },
        error => {
            if (mifidErrorDatePassed) {
                dispatch(fetchFundTransactionCostError(error));
                const errorKey = get(error, ['body', 'error'], '');
                dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
            }
        },
    );
};

const fetchFundTransactionCost = (fundIsin, history) => (dispatch, getState) => {
    const immAccessKey = getState().accessKeyChange;
    const immCmLegalDocuments = getState().cmLegalDocuments;
    const lastAccess = immAccessKey.getIn(['cmcContract', 'lastAccess']);
    const mifidErrorDatePassed = mifidErrorHelper.nationalIdDateValidation(
        lastAccess,
    );
    dispatch(fetchFundTransactionCostRequest());

    const data = {
        documentType: BROKER_DOCUMENT_TYPE,
        isin: fundIsin,
        orderType: BROKER_ORDER_TYPE_BUY,
    };

    const requestData = {
        query: data,
    };

    APIPost(dispatch, apiURLBuilder.getURL('getProductCost'), requestData).then(
        response => {
            if (response && response.objectId) {
                dispatch(
                    getFundsTransactionDocumentContent(
                        response.objectId,
                        mifidErrorDatePassed,
                        immCmLegalDocuments,
                        fundIsin,
                        history
                    ),
                );
            } else {
                if (mifidErrorDatePassed) {
                    dispatch(
                        errorActions.show(
                            'brokerAPIErrors-errorPrimaryMessage',
                            true,
                            history
                        ),
                    );
                }
            }
        },
        error => {
            if (mifidErrorDatePassed) {
                dispatch(fetchFundTransactionCostError(error));
                const errorKey = get(error, ['body', 'error'], '');
                dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
            }
        },
    );
};

const fetchLegalDocuments = (isin, history) => dispatch => {
    dispatch(fetchFundTransactionCost(isin, history));
    dispatch(fetchMorningStarExt(isin));
    dispatch(fetchMarketingReports(isin));
};

module.exports = {
    fetchLegalDocuments,
    fetchUnifiedDocument,
};
